import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/Layouts";
import { api, readUser, errMsg } from "../../lib/api";
import { Megaphone, Trash2, Send } from "lucide-react";

export default function AdminNotifications() {
  const user = readUser();
  const [data, setData] = useState({});
  const [current, setCurrent] = useState(null);
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [notice, setNotice] = useState({ ok: false, msg: "" });

  async function load() {
    const [o, s] = await Promise.all([api.get("/admin/overview"), api.get("/settings/public")]);
    setData(o.data);
    setCurrent((s.data || {}).active_announcement || null);
  }
  useEffect(() => { load().catch(() => {}); }, []);

  async function post(e) {
    e.preventDefault();
    setNotice({ ok: false, msg: "" });
    if (!text.trim()) return setNotice({ ok: false, msg: "Lütfen bir mesaj yazın." });
    try {
      const r = await api.post("/admin/announcement", { text: text.trim(), title: (title || "").trim() });
      setCurrent(r.data);
      setText("");
      setNotice({ ok: true, msg: "Duyuru yayında — tüm üyeler bir sonraki sayfa açılışında popup olarak görecek." });
    } catch (err) {
      setNotice({ ok: false, msg: errMsg(err) });
    }
  }

  async function clear() {
    if (!window.confirm("Aktif duyuruyu temizlemek istediğine emin misin?")) return;
    try {
      await api.delete("/admin/announcement");
      setCurrent(null);
      setNotice({ ok: true, msg: "Duyuru kaldırıldı." });
    } catch (err) {
      setNotice({ ok: false, msg: errMsg(err) });
    }
  }

  const items = [
    data.pending_deposits ? { kind: "warn", title: `${data.pending_deposits} depozito inceleme bekliyor`, link: "/admin/depozitolar" } : null,
    data.pending_withdrawals ? { kind: "warn", title: `${data.pending_withdrawals} çekim talebi onay bekliyor`, link: "/admin/cekimler" } : null,
    { kind: "info", title: `Toplam ${data.users || 0} üye kayıtlı`, link: "/admin/kullanicilar" },
    { kind: "info", title: `${data.active_user_packages || 0} paket aktif çalışıyor`, link: "/admin/uretimler" },
  ].filter(Boolean);

  return (
    <AdminLayout user={user} active="Bildirimler">
      <section className="admin-panel announcement-panel">
        <div className="admin-panel-title"><div><span className="eyebrow">PANEL DUYURUSU</span><h2><Megaphone size={18} /> Üyelere Popup Mesaj Gönder</h2></div></div>
        <p className="hint">Buradan yazdığın mesaj, oturumu açık her üyenin ekranına popup olarak çıkar. Üye kapatana kadar sağ üstte bir "duyuru rozeti" olarak kalır.</p>
        {current && (
          <div className="current-announcement" data-testid="admin-current-announcement">
            <div>
              <span className="eyebrow">AKTİF DUYURU</span>
              <strong>{current.title}</strong>
              <p>{current.text}</p>
              <small>Yayınlayan: {current.posted_by} · {new Date(current.posted_at).toLocaleString("tr-TR")}</small>
            </div>
            <button className="btn btn-ghost" onClick={clear} data-testid="admin-clear-announcement"><Trash2 size={14} /> Kaldır</button>
          </div>
        )}
        <form onSubmit={post} className="announcement-form">
          <label>Başlık (opsiyonel) <span className="optional">boş bırakılırsa üyeler "Announcement" görür</span>
            <input data-testid="admin-announcement-title" value={title} onChange={(e) => setTitle(e.target.value)} maxLength={120} placeholder="Örn: System Maintenance" />
          </label>
          <label>Mesaj
            <textarea data-testid="admin-announcement-text" rows={4} value={text} onChange={(e) => setText(e.target.value)} placeholder="Örn: Pazar günü 22:00-02:00 arası sistem bakımı yapılacaktır." maxLength={2000} />
          </label>
          {notice.msg && <div className={notice.ok ? "success" : "error"} data-testid="admin-announcement-notice">{notice.msg}</div>}
          <button className="btn btn-accent" data-testid="admin-announcement-submit"><Send size={14} /> Popup olarak yayınla</button>
        </form>
      </section>
      <section className="admin-panel">
        <div className="admin-panel-title"><div><span className="eyebrow">SİSTEM DURUMU</span><h2>Bildirimler</h2></div></div>
        <ul className="notif-list">
          {items.map((n, i) => (
            <li key={i} className={`notif ${n.kind}`} data-testid={`admin-notif-${i}`}>
              <span>{n.title}</span>
              <a href={n.link}>İncele →</a>
            </li>
          ))}
        </ul>
      </section>
    </AdminLayout>
  );
}
